import styled from "@emotion/styled"
// import { useEffect, useRef } from "react"

import { useConsole } from "contexts/Console"
// import QRCodeStyling from "qr-code-styling"
// import { useEnv } from "contexts/Env"

import getMediaQuery from "css/breakpoints"
import { body50, headline50 } from "css/text"
// import { useNavigation } from "contexts/Navigation"

import ModalContainer, { weChatModal } from "components/modal/ModalContainer"

// import { ReactComponent as ReactLogo } from "./wechatqrcode.svg"

const QRCodeContainer = styled.div`
  width: 70%;
  max-width: 260px;
  margin-block-end: 50px;
  align-self: center;
  margin-inline: auto;

  ${getMediaQuery("m")} {
    width: 100%;
    max-width: 360px;
    margin-block-end: 1.25rem;
  }

  > canvas,
  > img {
    height: 100%;
    width: 100%;
  }
`

const Heading = styled.h2`
  ${headline50}
  align-self: center;
  text-align: center;
`

const Paragraph = styled.p`
  ${body50}
  align-self: center;
  text-align: center;
  margin-block-start: 1.25rem;
`

export default function WeChatModal({ onClose, label, text, alt, qr_code }) {
  const console = useConsole()
  // const navigation = useNavigation()
  // const env = useEnv()
  // const qrRef = useRef(null)

  // const urlqr = navigation.localize(`/wishlist?rmc=(${JSON.parse(localStorage.getItem("rmcWishList"))})&cmpid=qrc_savedwishlist`)

  // const fullURL = `https://weixin.qq.com/r/mp/LkjSykbE3xugrQKp9x08`

  // const qrCode = useRef(
  //   new QRCodeStyling({
  //     // width: 100,
  //     // height: 100,
  //     data: fullURL,
  //     image: "/public/logo-texture.svg",
  //     type: "svg",
  //     // margin: 5,
  //     dotsOptions: {
  //       type: "dots",
  //       // color: "rgb(var(--green))",
  //       gradient: {
  //         type: "linear",
  //         rotation: 90,
  //         colorStops: [
  //           { offset: 0, color: "rgb(var(--gradient-qrcode-green-from))" },
  //           { offset: 100, color: "rgb(var(--gradient-qrcode-green-to))" },
  //         ],
  //       },
  //     },
  //     cornersSquareOptions: {
  //       type: "square",
  //       // color: "#1A5D42",
  //     },
  //     cornersDotOptions: {
  //       type: "square",
  //       // color: "#1A5D42",
  //     },
  //     backgroundOptions: {
  //       color: "#ffffff",
  //     },
  //   })
  // )

  // useEffect(() => {
  //   qrCode.current.update({ data: fullURL })
  //   if (qrRef.current) {
  //     // qrRef.current.innerHTML = ""
  //     qrCode.current.append(qrRef.current)
  //   }
  // }, [fullURL])

  // console.verbose("WeChatModal(%o)")

  const src = `${process.env.NODE_ENV === "development" ? "/public" : ""}/wechatqrcode.png`

  return (
    <ModalContainer wechat onClose={onClose} className={weChatModal} modalHeading='modal-heading' modalContent='modal-content' style={{ textAlign: "center" }}>
      <QRCodeContainer>
        <img alt={alt} src={src} />
      </QRCodeContainer>
      <Heading id='modal-heading'>{label}</Heading>
      <Paragraph id='modal-content'>{text}</Paragraph>
    </ModalContainer>
  )
}
